import React from "react";
import Seo, { breadcrumbJsonLd } from "@/components/Seo";
import { Breadcrumbs } from "@/components/common";
import { ACCESSIBILITY_STATEMENT, SITE } from "@/mock";

export default function AccessibilityStatement() {
  const crumbs = [
    { name: "Home", path: "/" },
    { name: "Accessibility Statement", path: "/accessibility-statement" },
  ];
  return (
    <>
      <Seo
        title="Accessibility Statement"
        description="MattressTown is committed to digital accessibility and strives to conform to WCAG 2.1 Level AA standards. Read our full accessibility statement."
        path="/accessibility-statement"
        jsonLd={breadcrumbJsonLd(crumbs)}
      />
      <Breadcrumbs items={crumbs} />

      <article className="mx-auto max-w-3xl px-4 py-8 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-bold uppercase text-neutral-900">Website Accessibility Statement</h1>
        <p className="mt-2 text-sm text-neutral-500">Last Updated: {ACCESSIBILITY_STATEMENT.updated}</p>

        <div className="mt-8 space-y-10">
          {ACCESSIBILITY_STATEMENT.sections.map((sec) => (
            <section key={sec.heading}>
              <h2 className="text-xl font-bold text-neutral-900">{sec.heading}</h2>
              {sec.body?.map((p, i) => (<p key={i} className="mt-3 leading-relaxed text-neutral-700">{p}</p>))}
              {sec.list && (
                <ul className="mt-3 list-disc space-y-1 pl-6 text-neutral-700">
                  {sec.list.map((li) => (<li key={li}>{li}</li>))}
                </ul>
              )}
              {sec.after?.map((p, i) => (<p key={i} className="mt-3 leading-relaxed text-neutral-700">{p}</p>))}
            </section>
          ))}
        </div>

        <div className="mt-10 rounded-xl border border-neutral-200 bg-cream p-6">
          <h2 className="text-lg font-bold text-neutral-900">Contact Us</h2>
          <p className="mt-2 text-neutral-700">If you encounter any accessibility barriers, please contact us at{" "}
            <a href={SITE.phoneHref} className="font-semibold text-[#D0021B] hover:underline">{SITE.phone}</a> or{" "}
            <a href={`mailto:${SITE.email}`} className="font-semibold text-[#D0021B] hover:underline">{SITE.email}</a>.
          </p>
        </div>
      </article>
    </>
  );
}
